import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { MainContainer } from '@core/Components/Containers'
import { ContentHeader } from '@core/Components/ContentHeader'
import { StructuredSearchCriteria } from './Criteria/StructuredSearchCriteria'
import { StructuredSearchResults } from './Results/StructuredSearchResults'
import {
  TabLabelResultsStyled,
  StructuredSearchTabListContainerStyled,
} from './StructuredSearch.styles'
import { Tabs, TabPanel, Tab, TabList } from '@core/Components/Tabs'
import { performStructuredSearch } from './Service/StructuredSearchService'
import { selectSearchCriteria, selectSearchResults } from './Store/selectors'

export const StructuredSearchPage = (): JSX.Element => {
  const testId = { 'data-tid-structured-search-container': '' }

  const searchResults = useSelector(selectSearchResults)
  const currentSearchCriteria = useSelector(selectSearchCriteria)

  const totalResultCount = searchResults.totalResultCount

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  React.useEffect(() => {
    performStructuredSearch(currentSearchCriteria)
  }, [currentSearchCriteria])

  return (
    <MainContainer {...testId}>
      <ContentHeader title='Smart Form' />

      <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex}>
        <StructuredSearchTabListContainerStyled>
          <TabList>
            <Tab data-tid-structured-search-tab='criteria'>Criteria</Tab>
            <Tab data-tid-structured-search-tab='results'>
              Results{' '}
              <TabLabelResultsStyled data-tid-total-result-count={totalResultCount}>
                {totalResultCount}
              </TabLabelResultsStyled>
            </Tab>
          </TabList>
        </StructuredSearchTabListContainerStyled>
        <TabPanel>
          <StructuredSearchCriteria selectTabIndex={x => setSelectedTabIndex(x)} />
        </TabPanel>
        <TabPanel>
          <StructuredSearchResults />
        </TabPanel>
      </Tabs>
    </MainContainer>
  )
}
